@if (parcelImage) {
  <div class="layout-container ">
    <div class=" left-column" style="flex: 1;position: relative;">
      @if (selectedFileName) {
        <app-file-viewer [fileName]="selectedFileName" [fileUrl]="selectedFileUrl"
        [itemId]="itemId" [fromTab]="'PDTab'"></app-file-viewer>
      }
    </div>
    <div class=" right-column ">
      <div class="p-d-flex p-flex-column p-ai-end p-gap-3">
        <ngx-barcode6 [bc-format]="'code128'" [bc-value]="itemId" [bc-display-value]="true"
          style="width: 250px; height: 100px;">
        </ngx-barcode6>
        @if (!hideAssignActions) {
          <div class="assign-actions p-2">
            <!-- User dropdown (searchable + scrollable) -->
            <p-select appendTo="body" [options]="users" [filter]="true" filterPlaceholder="Search user..."
              [loading]=userDropDownSelected [disabled]="(userDropDownSelected || btnDisable)"
              placeholder="Assign to user" [style]="{width: '180px'}"
              (onChange)="onSelectionChange()" [(ngModel)]="selectedOption">
            </p-select>
            @if (showUnassignBtn) {
              <p-button icon="pi pi-user-minus" [rounded]="true" [text]="true" severity="danger" pTooltip="Unassign"
                class="ml-2" tooltipPosition="top" (onClick)="onUnAssign()"
                [disabled]="(btnDisable || userDropDownSelected)" />
            }
            @if (showFinishBtn) {
              <p-button icon="pi pi-check-circle" [rounded]="true" [text]="true" severity="success"
                pTooltip="Finished" class="ml-1" tooltipPosition="top" (onClick)="onHandled()"
                [disabled]="(btnDisable || userDropDownSelected)" />
            }
          </div>
        }
        @if (versions.length > 0) {
          <div class="tables-container" class="">
            <p-table showGridlines [value]="images" class="p-datatable">
              <ng-template pTemplate="header">
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Name</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-image>
                <tr>
                  <td>{{ image['imageDateTime'] | formatDateTime: 'return-date' }}</td>
                  <td>{{ image['imageDateTime'] | formatDateTime: 'return-time' }}</td>
                  <td>
                    <!-- Make image name clickable -->
                    <a href="javascript:void(0)" class="text-to-button truncate-text"
                      (click)="onImageClick($event, image)" [pTooltip]=image.imageName
                      tooltipPosition="top">
                      {{ image['imageName'] }}
                    </a>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
      </div>
    </div>
  </div>
} @else {
}
<!-- <div class="p-fluid p-m-3 show-on-print">
<div class="p-d-flex p-jc-center p-mt-3">
  <div class="preview-container">
    <app-file-viewer *ngIf="selectedFileName" [fileName]="selectedFileName"
    [fileUrl]="selectedFileUrl"></app-file-viewer>
    <div class="annotation ">
      <ngx-barcode6 [bc-format]="'code128'" [bc-value]="itemId" [bc-display-value]="true">
      </ngx-barcode6>
    </div>
  </div>
</div>
</div> -->